<script>
    import ForgotPassword from '/public/components/users/ForgotPassword.svelte';
</script>

<div class='vh-100'>
    <div class='container-fluid'>
        <div class="row justify-content-center mt-5 mb-5">
            <div class="col-sm-12 col-md-10 col-lg-8 col-xl-4 col-xxl-4">

                <ForgotPassword/>

            </div>
        </div>
    </div>
</div>
